import React, { useEffect, useState } from "react";
import { Card, List, Descriptions, Image } from "antd";
import { API_METHODS, BLANK_VALUE } from "../../constants";
import useApi from "../../hooks/useApi";
import { useParams } from "react-router-dom";

function ViewTest() {
  const { test_id } = useParams();
  const [responseData, getRequest] = useApi(
    `/admin/test/${test_id}`,
    null,
    API_METHODS.GET
  );
  const [testData, setTestData] = useState();
  const [items, setItems] = useState();

  useEffect(() => {
    getRequest();
  }, []);

  useEffect(() => {
    const data = responseData.data !== BLANK_VALUE ? responseData.data : [];
    setTestData(data);
    if (data) {
      let items = [
        {
          key: "1",
          label: "Test Name",
          children: data.test_name,
        },
        {
          key: "2",
          label: "Test Type",
          children: data.test_type,
        },
        {
          key: "3",
          label: "Total Time",
          children: data.total_time,
        },
        {
          key: "4",
          label: "Month",
          children: data.month,
        },
        {
          key: "5",
          label: "Week",
          children: data.week,
        },
        {
          key: "6",
          label: "Description",
          children: data.description,
        },
      ];
      setItems(items);
    }
  }, [responseData]);

  return (
    <>
      <Card title="Details">
        <Descriptions bordered items={items} style={{ margin: 5 }} />
        {testData && testData.test_type_id != 3 && (
          <List
            dataSource={testData?.questions}
            renderItem={(item) => (
              <List.Item>
                <Card
                  title={`Question ${item.question_number}`}
                  style={{ width: "100%" }}
                >
                  <p>{item.question_text}</p>

                  {item.image != BLANK_VALUE && (
                    <Image width={200} src={item.image} />
                  )}
                  {item.options.map((option, index) => (
                    <>
                      <div key={index}>
                        <strong>{option.option_label}</strong>:{" "}
                        {option.option_text}
                        {option.is_correct_option && (
                          <span style={{ color: "green" }}> (Correct)</span>
                        )}
                      </div>
                      {option.image != BLANK_VALUE && (
                        <Image width={200} src={option.image} />
                      )}
                    </>
                  ))}
                </Card>
              </List.Item>
            )}
          />
        )}
        {testData && testData.test_type_id == 3 && (
          <>
            <p>Mock Test Number -{testData.mock_test_number} </p>
            <List
              dataSource={testData?.sections}
              renderItem={(item) => (
                <List.Item>
                  <Card title={item.name} style={{ width: "100%" }}>
                    <p>Time Limit -{item.time_limit}</p>
                    <List
                      dataSource={item.questions}
                      renderItem={(inner_item) => (
                        <List.Item>
                          <Card
                            title={`Question ${inner_item.question_number}`}
                            style={{ width: "100%" }}
                          >
                            <p>{inner_item.question_text}</p>
                            {inner_item.image != BLANK_VALUE && (
                              <Image width={200} src={inner_item.image} />
                            )}

                            {inner_item.options.map((option, index) => (
                              <>
                                <div key={index}>
                                  <strong>{option.option_label}</strong>:
                                  {option.option_text}
                                  {option.is_correct_option && (
                                    <span style={{ color: "green" }}>
                                      (Correct)
                                    </span>
                                  )}
                                </div>
                                {option.image != BLANK_VALUE && (
                                  <Image width={200} src={option.image} />
                                )}
                              </>
                            ))}
                          </Card>
                        </List.Item>
                      )}
                    />
                  </Card>
                </List.Item>
              )}
            />
          </>
        )}
      </Card>
    </>
  );
}

export default ViewTest;
